import config from '@/config'
import { ITrackCommunitiesAccessEvent, ITrackEvent } from '@/models/TrackEvent'
import { useGlobalStore } from '@/store/app'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class AnalyticsServiceCls {
  protected basePath = '/health'

  constructor() {}

  async trackEvent(trackEvent: ITrackEvent): Promise<void> {
    const appStore = useGlobalStore()

    const enrichedTrackEvent = {
      ...trackEvent,
      locationId: appStore.locationId,
      groupId: appStore.groupId,
    }

    await http.post(`${this.basePath}/track-event`, enrichedTrackEvent)
  }

  async trackCommunitiesAccessEvent(
    trackEvent: ITrackCommunitiesAccessEvent
  ): Promise<void> {
    await http.post(
      `${this.basePath}/track-communities-access-event`,
      trackEvent
    )
  }
}

// Export singleton instance
export const AnalyticsService = new AnalyticsServiceCls()

// Export type for dependency injection
export type IAnalyticsService = AnalyticsServiceCls

// Export commonly used methods directly
export const { trackEvent } = AnalyticsService
